import React from 'react';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import * as httpService from '../../services/HTTPService';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import SpinLoader from '../spin-loader';
import { hideOverlay } from '../../utils/utils';
import { useNavigate } from "react-router-dom";
import PartnersBanner from '../partners-banner';

function RegisterForm() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [validated, setValidated] = useState(false);
  const [visiblePass, setVisiblePass] = useState(false);
  let [isSpinning, setIsSpinning] = useState(false);
  const defaultFormData = {
    address: "",
    city: "",
    company: "",
    country: "",
    email: "",
    firstName: "",
    lastName: "",
    password: "",
    phone: "",
    postalCode: "",
    profession: "",
    websiteOrSocial: "",
  }
  let [regForm, setRegForm] = useState(defaultFormData);
 
  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form: any = event.currentTarget;
    let registerData: any  = {...regForm};
    const data:any = new FormData(event.currentTarget)
    //let formObject = Object.fromEntries(data.entries())
    for (let [key, value] of data.entries()) {
        registerData[key] = value;
        //console.log(key, value);
    }
    regForm = registerData;
    setRegForm(registerData);
    
    if (form.checkValidity() === true) {
        registerUser(regForm);
    }
    setValidated(true);
  };

  const registerUser = (user: any) => {
    setIsSpinning(true);
    httpService.registerUser(JSON.stringify(user)).then((res) => {
        if(res) {
            console.log(res);
            navigate('/login');
            toast.success(t('forms.registrationSuccessful'));
        }
        const registerForm: any = document.querySelector('form');
        registerForm.classList.remove('was-validated');
        registerForm.reset();
        hidePreloader();
    })
    .catch((err) => {
        //const registerForm: any = document.querySelector('form');
        //registerForm.reset();
        console.log(err);
        const msg = err.response.data ? err.response.data: t('forms.commonErrMsg');
        hidePreloader();
        toast.error(msg);
    })
  }

  const togglePass = () => {
    setVisiblePass(!visiblePass);
  }

  const hidePreloader = () => {
    hideOverlay();
    setIsSpinning(false);
    }

  return (
    <div>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="emailReg">
                    <Form.Label>{t('forms.email')}*</Form.Label>
                    <Form.Control 
                        type="email"
                        name="email"
                        required
                    />
                    <Form.Control.Feedback type="invalid">
                        {t('forms.validEmailError')}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="nameReg">
                    <Form.Label>{t('forms.name')}*</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        name="firstName"
                        defaultValue=""
                    />
                    <Form.Control.Feedback type="invalid">
                        {t('forms.requiredFieldError', { field: t('forms.name')})}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="lastNameReg">
                <Form.Label>{t('forms.lname')}*</Form.Label>
                <Form.Control
                    required
                    type="text"
                    name="lastName"
                    defaultValue=""
                />
                <Form.Control.Feedback type="invalid">
                    {t('forms.requiredFieldError', { field: t('forms.lname')})}
                </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="profReg">
                <Form.Label>{t('forms.profession')}*</Form.Label>
                <Form.Control
                    required
                    type="text"
                    name="profession"
                    defaultValue=""
                />
                <Form.Control.Feedback type="invalid">
                    {t('forms.requiredFieldError', { field: t('forms.profession')})}
                </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="phoneReg">
                    <Form.Label>{t('forms.phone')}*</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        name="phone"
                        defaultValue=""
                    />
                    <Form.Control.Feedback type="invalid">
                            {t('forms.requiredFieldError', { field: t('forms.phone')})}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
            <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="companyReg">
                    <Form.Label>{t('forms.company')}*</Form.Label>
                    <Form.Control type="text" name="company" required />
                    <Form.Control.Feedback type="invalid">
                        {t('forms.requiredFieldError', { field: t('forms.company')})}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="12" controlId="WebsiteReg">
                    <Form.Label>{t('forms.websiteOrSocial')}*</Form.Label>
                    <Form.Control type="text" name="websiteOrSocial" />
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="validationCustom04">
                    <Form.Label>{t('forms.country')}*</Form.Label>
                    <Form.Control type="text" name="country" required />
                    <Form.Control.Feedback type="invalid">
                        {t('forms.requiredFieldError', { field: t('forms.country')})}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="validationCustom05">
                    <Form.Label>{t('forms.postalCode')}</Form.Label>
                    <Form.Control type="text" name="postalCode" />
                </Form.Group>
                <Form.Group as={Col} md="12" controlId="validationCustom06">
                    <Form.Label>{t('forms.city')}*</Form.Label>
                    <Form.Control type="text" name="city" required />
                    <Form.Control.Feedback type="invalid">
                        {t('forms.requiredFieldError', { field: t('forms.city')})}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="12" controlId="validationCustom06">
                    <Form.Label>{t('forms.address')}*</Form.Label>
                    <Form.Control type="text" name="address" required />
                    <Form.Control.Feedback type="invalid">
                        {t('forms.requiredFieldError', { field: t('forms.address')})}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="12" controlId="validationCustom07" className='pass-group'>
                    <Form.Label>{t('forms.password')}*</Form.Label>
                    <Form.Control type={visiblePass ? "text" : "password"} name="password" required />
                    <span className='showPassBtn' onClick={togglePass}></span>
                    <Form.Control.Feedback type="invalid">
                        {t('forms.requiredFieldError', { field: t('forms.password')})}
                    </Form.Control.Feedback>
                </Form.Group>
                <div className='align-center btn-out btn-white'>
                    <Button type="submit">{t('forms.registerbutton')}</Button>
                </div>
            </Row>
            <Row className="mb-3">
                <PartnersBanner />
            </Row>
        </Form>
        <ToastContainer position="top-center"
 />
        {isSpinning ? (
            <SpinLoader />
        ) : null}
    </div>
  );
}

export default RegisterForm;